export const MenuIcon = () => (
  <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0.677979V3.92677H27.6562V0.677979H0ZM0 10.3269V13.5757H27.6562V10.3269H0ZM0 20.0732V23.322H27.6562V20.0732H0Z"
      fill="black"
    />
  </svg>
);
